export const environment = {
  production: true,
  apiUrl: 'https://staging.survey.renovars.fullstackagency.it/api',
  tokenLength: 6,
  showWelcomePage: false,
};
